import { CognitoUserPool } from 'amazon-cognito-identity-js'

const poolData = {
    UserPoolId: 'us-east-1_5C8IjdzCH',
    ClientId: '60gnn9iluls6kmll76eutushg3',
}

export default new CognitoUserPool(poolData)